var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":_vm.color,"fab":"","small":"","left":""},on:{"click":function($event){return _vm.$vuetify.goTo(_vm.scrollToElement)}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }